/**
 * REGISTRE DES ALIAS TOKENS OLIVER — Singleton
 * Natures de base : table, doc, chart, data, metric.
 * Les alias (ex: actif, broker) pointent vers une nature + table + clé.
 */
const BASE_NATURES = new Set(['table', 'doc', 'chart', 'data', 'metric']);

class AIAliasRegistry {
  static #instance = null;

  constructor() {
    this.aliases = new Map(); // alias → config
  }

  static getInstance() {
    if (!AIAliasRegistry.#instance) {
      AIAliasRegistry.#instance = new AIAliasRegistry();
    }
    return AIAliasRegistry.#instance;
  }

  registerAlias({ alias, nature, table, key, label, description, icon, examples = [] }) {
    if (!BASE_NATURES.has(nature)) {
      console.error(`[AIAliasRegistry] ❌ Nature inconnue "${nature}" pour alias "$${alias}"`);
      return;
    }
    if (BASE_NATURES.has(alias)) {
      console.error(`[AIAliasRegistry] ❌ "$${alias}" est une nature de base, ne peut pas être un alias`);
      return;
    }
    this.aliases.set(alias.toLowerCase(), {
      alias,
      nature,
      table,
      key,
      label,
      description,
      icon,
      examples,
    });
  }

  /**
   * Résout un token (nature ou alias) vers sa config complète
   * @returns {{ nature, isBase, table?, key?, label?, ... } | null}
   */
  resolve(token) {
    const t = token.toLowerCase();
    if (BASE_NATURES.has(t)) return { nature: t, isBase: true };
    if (this.aliases.has(t)) return { ...this.aliases.get(t), isBase: false };
    return null;
  }

  /**
   * Pour l'autocomplétion : retourne toutes les suggestions $token (natures + alias)
   */
  getAllTokens() {
    const base = Array.from(BASE_NATURES).map((n) => ({
      token: `$${n}`,
      label: n,
      isAlias: false,
    }));
    const aliasTokens = Array.from(this.aliases.values()).map((a) => ({
      token: `$${a.alias}`,
      label: a.label,
      description: a.description,
      icon: a.icon,
      examples: a.examples,
      isAlias: true,
    }));
    return [...base, ...aliasTokens];
  }
}

export { AIAliasRegistry, BASE_NATURES };
